import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ReadMore = ({ to, testid, className = '', children = 'Read more' }) => (
  <Link to={to} data-testid={testid}
    className={`group inline-flex items-center gap-3 rounded-full border border-[#FF7A00]/60 bg-[#FF7A00]/10 pl-5 pr-1.5 py-1.5 text-sm font-semibold text-[#FF7A00] hover:bg-[#FF7A00] hover:text-black hover:border-[#FF7A00] hover:shadow-[0_0_24px_rgba(255,122,0,0.35)] transition-[background-color,color,box-shadow,border-color] duration-300 ${className}`}>
    {children}
    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#FF7A00] text-black group-hover:bg-black group-hover:text-[#FF7A00] transition-colors duration-300">
      <ArrowRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300" />
    </span>
  </Link>
);
